"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const rc_tooltip_1 = __importDefault(require("rc-tooltip"));
const placementToOffset = {
  top: {
    offset: [0, 0]
  },
  bottom: {
    offset: [0, 0]
  },
  left: {
    offset: [0, 0]
  },
  right: {
    offset: [0, 0]
  }
};
const Tooltip = props => {
  const {
    content = null,
    children,
    placement = 'top',
    ...rest
  } = props;
  return (0, jsx_runtime_1.jsx)(rc_tooltip_1.default, {
    overlay: content,
    placement: placement,
    align: placementToOffset[placement],
    ...rest,
    children: children
  });
};
exports.default = Tooltip;